/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Expand({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} clipPath="url(#Expand_svg__a)"><path d="M14.438 6.492H1.563M14.438 9.508H1.563M9.792 13.208 8 15 6.21 13.208M8 15v-3.5M6.208 2.792 8 1 9.79 2.792M8 1v3.5" /></g><defs><clipPath id="Expand_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;